import { FormEvent, FunctionComponent, useState } from 'react'
import { useParams } from 'react-router-dom'
import * as S from './styled'
import { productKeyMap } from './ProductKeyMaps'
import moment from 'moment'
import { getAuth } from 'firebase/auth'
import requestActions from '../../redux/requests/requestActions'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router'
import { Icon } from '../../components/atoms/Icons/Icon'

type OwnProps = {}

type Props = OwnProps

export const CreateDocument: FunctionComponent<Props> = () => {
  const [productData, setProductData] = useState<any>({})
  const dispatch = useDispatch()
  const history = useHistory()
  const { product } = useParams<{ product: string }>()
  const auth = getAuth()
  const user = auth.currentUser
  const keyMap = productKeyMap[product]
  console.log({ keyMap })

  function handleSubmit(event: FormEvent<HTMLFormElement>): void {
    event.preventDefault()

    const newProduct = {
      ...productData,
      date: moment(new Date()).format('YY-MM-DD HH:mm:ss'),
      product,
      uploadedBy: user!.email,
      fileName: `${productData.company} ${productData.settlementDate}`,
      week: moment(productData.settlementDate, 'YYYY-MM-DD').isoWeek(),
      hasPDF: false,
    }
    console.log({ newProduct })
    dispatch(requestActions.products.createDocument(newProduct, product, user!.uid))
    history.push('/documents')
  }

  return (
    <S.Container>
      <h1>{`${product[0].toUpperCase()}${product.substring(1)}`}</h1>
      <form onSubmit={handleSubmit}>
        <>
          {keyMap &&
            keyMap.map((key, i) => {
              return (
                <S.Div key={i}>
                  {key.icon && (
                    <S.Icon>
                      <Icon iconName={key.icon} />
                    </S.Icon>
                  )}
                  <label>{key.displayKey.language.sv}</label>
                  <input
                    required={key.required}
                    max={key.dataKey === 'settlementDate' ? moment().format('YYYY-MM-DD') : ''}
                    type={key.type}
                    onChange={e => {
                      setProductData({ ...productData, [key.dataKey]: e.target.value })
                    }}
                  ></input>
                </S.Div>
              )
            })}
        </>
        <S.Button type="submit">Spara</S.Button>
      </form>
    </S.Container>
  )
}
